import { IVFSResponse, Webhook } from '../types';
import { Integrations, InitGoogleCalendarIntegrationData } from './types';
import BaseAPI from '../BaseAPI';

/**
 * Integration API
 * Handles third-party integrations
 */
class IntegrationAPI extends BaseAPI {
  /**
   * Initialize Google Calendar integration
   */
  async initGoogleCalendar(): Promise<
    IVFSResponse<InitGoogleCalendarIntegrationData>
  > {
    return this.wrapResponse<InitGoogleCalendarIntegrationData>({
      promise: this.apiInstance.get('/v2/integrate/google/calendar/init'),
      errorMessage: 'Failed to initialize Google Calendar integration',
    });
  }

  /**
   * Disconnect Google Calendar integration
   */
  async disconnectGoogleCalendar(): Promise<IVFSResponse<void>> {
    return this.wrapResponse<void>({
      promise: this.apiInstance.post(
        '/v2/integrate/google/calendar/disconnect'
      ),
      errorMessage: 'Failed to disconnect Google Calendar integration',
    });
  }

  /**
   * Disconnect Zoom integration
   */
  async disconnectZoom(): Promise<
    IVFSResponse<{ integrations: Integrations }>
  > {
    return this.wrapResponse<{ integrations: Integrations }>({
      promise: this.apiInstance.post('/v2/integrations/zoom/disconnect'),
      errorMessage: 'Failed to disconnect Zoom integration',
    });
  }

  /**
   * Add a webhook URL for the user
   * @param params - Webhook data
   */
  async addWebhook(params: Webhook): Promise<IVFSResponse<void>> {
    return this.wrapResponse<void>({
      promise: this.apiInstance.post('/v2/integrations/webhook', params),
      errorMessage: 'Failed to add webhook',
    });
  }

  /**
   * Remove a webhook URL for the user
   * @param params - Webhook data
   */
  async removeWebhook(params: { url: string }): Promise<IVFSResponse<void>> {
    return this.wrapResponse<void>({
      promise: this.apiInstance.delete('/v2/integrations/webhook', {
        params,
      }),
      errorMessage: 'Failed to remove webhook',
    });
  }
}

export default IntegrationAPI;
